import { render, staticRenderFns } from "./FoodHub.vue?vue&type=template&id=b957c33e&scoped=true&"
import script from "./FoodHub.vue?vue&type=script&lang=js&"
export * from "./FoodHub.vue?vue&type=script&lang=js&"
import style0 from "./FoodHub.vue?vue&type=style&index=0&id=b957c33e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b957c33e",
  null
  
)

export default component.exports